import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { usePageTitle } from '@/lib/use-page-title'

export const EmailLogin = () => {
  const { t } = useTranslation(['auth', 'common'])
  usePageTitle('email_login_title', 'auth')

  return (
    <main className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>{t('email_login_title')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">{t('common:fields.email')}</Label>
            <Input id="email" type="email" inputMode="email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">{t('common:fields.password')}</Label>
            <Input id="password" type="password" />
          </div>
          <Button className="w-full" asChild>
            <Link to="/login">{t('common:actions.back_login')}</Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  )
}
